/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import {Heading} from '~/components/data-display/Heading';
import {Container, ContainerInset} from '~/components/layout/Container';
import {LpFooter} from '~/components/layout/LpFooter';
import {LpHeader} from '~/components/layout/LpHeader';
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h2: "h2",
    ol: "ol",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(LpHeader, {}), "\n", _jsx(Heading, {
      variant: "h1",
      component: "h1",
      children: _jsx(_components.p, {
        children: "個人情報の取り扱いについて"
      })
    }), "\n", _jsx("div", {
      className: "mdx",
      children: _jsx(Container, {
        children: _jsxs(ContainerInset, {
          children: [_jsx(_components.p, {
            children: "個人情報の取り扱いについて"
          }), _jsx(_components.p, {
            children: "株式会社 Foodies Prime（以下、「当社」といいます。住所および代表者の氏名については第 11 条をご覧ください。）は、当社の提供するサービス（以下、「本サービス」といいます。）における、ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。"
          }), _jsx(_components.h2, {
            children: "第 1 条（個人情報）"
          }), _jsx(_components.p, {
            children: "「個人情報」とは、平成 15 年法律第 57 号、個人情報の保護に関する法律（以下、「個人情報保護法」といいます。）にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。"
          }), _jsx(_components.h2, {
            children: "第 2 条（個人情報の収集方法）"
          }), _jsx(_components.p, {
            children: "当社は、以下の方法で個人情報を取得します。"
          }), _jsx(_components.p, {
            children: "(1) ユーザー・顧客等から直接提供を受ける方法"
          }), _jsx(_components.p, {
            children: "(2) ユーザー・顧客等がウェブサイトやアプリを利用することで、自動的に記録する方法"
          }), _jsx(_components.p, {
            children: "(3) 第三者が取得した個人情報の提供を受ける方法"
          }), _jsx(_components.p, {
            children: "(4) 第三者が取得したインフォマティブデータの提供を受けて当社の保有する個人情報と照合する方法"
          }), _jsx(_components.p, {
            children: "(5) 刊行物やインターネット等により公開情報を入手する方法"
          }), _jsx(_components.h2, {
            children: "ウェブサイトまたはアプリの利用に関するデータの取得及び利用"
          }), _jsx(_components.p, {
            children: "(1) インフォマティブデータについて"
          }), _jsx(_components.p, {
            children: "本ポリシーにおいて、インフォマティブデータとは、クッキー（Cookie）、ローカルストレージ、Web ビーコン、端末識別子等により記録されるユーザーのパソコンやスマートフォン、携帯電話等の情報通信端末に関する情報や行動履歴情報等、その他個人に関する情報であって、単体では特定の個人を識別できない情報のことをいいます。当社は、インフォマティブデータを取得及び利用することがあります。インフォマティブデータは、キャリア決済等のためにシステム上で自動的に個人情報と照合される場合や、ユーザー・取引先等からのお問い合わせへの適切な対応、システム管理、不正行為の防止・検証・取締り、セキュリティの向上等の目的のために個人情報と照合される場合があります。この場合、当社は、インフォマティブデータについても、個人情報として取り扱います。"
          }), _jsx(_components.p, {
            children: "当社が取得するインフォマティブデータには以下の情報が含まれます。"
          }), _jsx(_components.p, {
            children: "端末 ID 等の情報通信端末の端末識別に関する情報\nユーザーエージェント\n情報通信端末の OS 情報、インターネットへの接続に関する情報\nリファラ\nIP アドレス\n位置情報\n閲覧した URL および閲覧した日時に関するタイムスタンプ\nウェブ予約数、架電数、ページビュー数、その他当社のサービス上に記録される情報その他のサーバーログ情報"
          }), _jsx(_components.p, {
            children: "(2) クッキー等について"
          }), _jsx(_components.p, {
            children: "クッキー、ローカルストレージ、IndexedDB 等は、ウェブサイトの提供者がブラウザを通してサイト利用者のコンピュータにデータを記録する仕組みです（以下、これらと同様の仕組みを持つ技術を総称して「クッキー等」といいます）。 当社は、[1]ウェブサイトの動作に必須のクッキー等、[2]ウェブサイトの利用状況を把握するためのクッキー等、[3]利用者の興味・関心に関連する効果的なコンテンツの提供・広告（ターゲティング広告を含みます）配信のためのクッキー等を利用しています。 ユーザーが当社ウェブサイトを訪問することによって、当社からユーザーの端末へクッキー等が発行される場合と、第三者からユーザーの端末へクッキー等が発行される場合があります。第三者により発行されるクッキー等については、第三者が管理しており、当該第三者のプライバシーポリシー等の取り決めに従って取り扱われます。 当社は、クッキー等を、データマネジメントプラットフォーム（DMP）に蓄積して、利用する場合があります。"
          }), _jsx(_components.p, {
            children: "(3) 端末識別子について"
          }), _jsx(_components.p, {
            children: "当社は、当社の iOS 版・Android 版アプリをダウンロードしたスマートデバイス端末から、端末識別子（Apple 社が発行する IDFA や Google 社が発行する AAID 等の広告識別子を含みます。）を取得することがあります。当社における端末識別子の利用は、ユーザーのアク セス状況の把握、ユーザーのニーズに適したサービスの提供、サービスの改善、またはマーケティングリサーチや広告配信の最適化のために行います。なお、IDFA や AAID などの広告識別子については、広告配信の最適化目的のためにのみ利用します。 IDFA や AAID などの広告識別子によるターゲティング広告を停止する場合は、ユーザーのご利用端末の「設定」から、オプトアウト（無効化）してください。"
          }), _jsx(_components.p, {
            children: "(4) 位置情報について"
          }), _jsx(_components.p, {
            children: "当社は、当社のアプリをご利用時にユーザーの同意があった場合に限り、ユーザーのご利用端末の GPS 機能を利用して、当社のアプリを利用されているユーザーのご利用端末の緯度経度情報を取得しています。 当社は、ユーザーの位置情報を、単体で、または、当社サービスの利用履歴等と組み合わせることによって、ユーザーに有益な情報（おすすめのお店・ファッション・サービス、天気予報等）の配信、当社サービスの品質向上の目的で利用します。 位置情報の取得を停止する場合は、ユーザーのご利用端末の「設定」から、オプトアウト（無効化）してください。"
          }), _jsx(_components.h2, {
            children: "第 3 条（個人情報を収集・利用する目的）"
          }), _jsx(_components.p, {
            children: "当社は、個人情報及びインフォマティブデータを次の目的で利用します。"
          }), _jsx(_components.p, {
            children: "(1) 顧客情報"
          }), _jsx(_components.p, {
            children: "[1] ログイン時における本人確認のため"
          }), _jsx(_components.p, {
            children: "[2] メールマガジン等の情報配信のため（※）"
          }), _jsx(_components.p, {
            children: "[3] 当社が提供するウェブサイトを通じてのサービス提供のため"
          }), _jsx(_components.p, {
            children: "[4] 顧客・取引先等からの問い合わせへの対応のため"
          }), _jsx(_components.p, {
            children: "[5] 顧客からの申込内容に従って見積書等作成のために提携先企業へ提供するため"
          }), _jsx(_components.p, {
            children: "[6] 個人を識別できない形式に加工した上、統計データを作成し、当社の新サービス開発の資料として利用するため"
          }), _jsx(_components.p, {
            children: "[7] 当社又は当社グループ会社のウェブサイトやアプリを運営し、商品又はサービスを提供するため（※）"
          }), _jsx(_components.p, {
            children: "[8] 当社又は当社グループ会社のウェブサイトやアプリの利用状況を把握、分析するため（※）"
          }), _jsx(_components.p, {
            children: "[9] 当社又は当社グループ会社の提供する商品又はサービスの改善（不正の検知・追跡、操作性、セキュリティ、品質、利便性の向上等）又は開発のため。（※）"
          }), _jsx(_components.p, {
            children: "[10] 当社、当社グループ会社、または、当社/当社グループ会社の提携先又は広告主の提供する商品又はサービスに関する効果的な広告（ターゲティング広告を含みます）配信、および、広告効果の計測のため（※）"
          }), _jsx(_components.p, {
            children: "[11] 当社又は第三者の媒体において、広告等の情報、その他当社がユーザーにとって有益と考える情報を配信するため（※）"
          }), _jsx(_components.p, {
            children: "[12] 当社の提携先とのデータを活用したビジネスの開発、実行のため（※）"
          }), _jsx(_components.p, {
            children: "[13] サービス利用者数、ページビュー数などの統計データを、IR 情報として公開するため"
          }), _jsx(_components.p, {
            children: "[14] 前各号の利用目的のために、当社グループ会社、広告配信事業者、広告主、広告代理店、当社の提携先、その他の第三者に提供するため（※）"
          }), _jsx(_components.p, {
            children: "(2) 営業活動、公開情報等により入手した情報"
          }), _jsx(_components.p, {
            children: "営業活動、与信管理、業務連絡（※）"
          }), _jsx(_components.p, {
            children: "(3) 従業者情報（派遣社員、アルバイト、退職者を含む）"
          }), _jsx(_components.p, {
            children: "業務連絡、人事管理、広報"
          }), _jsx(_components.p, {
            children: "(4) 採用活動応募者情報"
          }), _jsx(_components.p, {
            children: "当社および、当子会社の採用選考、応募者への連絡、採用時の入社手続き ※インフォマティブデータ、ウェブの閲覧履歴及びサービスの利用履歴等の情報を分析した結果を利用する場合もあります。 なお、当社は個人情報の利用目的の達成に必要な範囲内で業務委託する場合があります。この場合、当社は、委託先に個人情報の保護を義務付け、適切な監督を実施します。"
          }), _jsx(_components.h2, {
            children: "第 4 条（利用目的の変更）"
          }), _jsx(_components.p, {
            children: "当社は、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。\n利用目的の変更を行った場合には、変更後の目的について、当社所定の方法により、ユーザーに通知し、または本ウェブサイト上に公表するものとします。"
          }), _jsx(_components.h2, {
            children: "第 5 条（第三者提供に関する事項）"
          }), _jsx(_components.p, {
            children: "当社は、取得した個人情報を適切に管理し、次の場合を除きあらかじめ本人の同意を得ることなく第三者に提供することはありません。"
          }), _jsx(_components.p, {
            children: "(1) 法令に基づく場合"
          }), _jsx(_components.p, {
            children: "(2) 人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき"
          }), _jsx(_components.p, {
            children: "(3) 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき"
          }), _jsx(_components.p, {
            children: "(4) 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき"
          }), _jsx(_components.p, {
            children: "当社は、第 3 条(1)記載の利用目的のために、インフォマティブデータを、当社グループ会社、広告配信事業者、広告主、広告代理店、当社の提携先、その他の第三者に対し提供する場合があります。当社が提供したインフォマティブデータを第三者にて個人データと照合することが想定される場合には、当社は、法令等に従い適切に対応いたします。"
          }), _jsx(_components.p, {
            children: "当社は、第 3 条(1)記載の利用目的の達成に必要な範囲内で、個人情報の全部又は一部を当社の業務委託先へ提供することがあります。この場合、当社は、業務委託先に対し情報管理に関する適切な監督を行った上で提供を行います。\n業務委託先への提供においては、当該業務委託先が、自らが保有する本人に関する情報と当社から提供された個人情報を突合することがあります。本ポリシーへの同意をもって、上記の突合についてもご同意いただいたこととなりますので、ご留意ください。"
          }), _jsx(_components.h2, {
            children: "第 6 条（個人情報の開示）"
          }), _jsxs(_components.ol, {
            children: ["\n", _jsx(_components.li, {
              children: "当社は、本人から個人情報保護法に従い、当社が定める手続きにより、個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。なお、個人情報の開示に際しては、1 件あたり 1,000 円の手数料を申し受けます。"
            }), "\n"]
          }), _jsx(_components.p, {
            children: "(1) 本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合"
          }), _jsx(_components.p, {
            children: "(2) 当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合"
          }), _jsx(_components.p, {
            children: "(3) その他法令に違反することとなる場合"
          }), _jsxs(_components.ol, {
            start: "2",
            children: ["\n", _jsx(_components.li, {
              children: "前項の定めにかかわらず、履歴情報および特性情報などの個人情報以外の情報については、原則として開示いたしません。"
            }), "\n"]
          }), _jsx(_components.h2, {
            children: "第 7 条（個人情報の訂正および削除）"
          }), _jsx(_components.p, {
            children: "ユーザーは、当社の保有する自己の個人情報が誤った情報である場合には、個人情報保護法に基づき、当社が定める手続きにより、当社に対して個人情報の訂正、追加または削除（以下、「訂正等」といいます。）を請求することができます。\n当社は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。\n当社は、前項の規定に基づき訂正等を行った場合、または訂正等を行わない旨の決定をしたときは遅滞なく、これをユーザーに通知します。"
          }), _jsx(_components.h2, {
            children: "第 8 条（個人情報の利用停止等）"
          }), _jsx(_components.p, {
            children: "当社は、本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由により、個人情報保護法に基づき、当社が定める手続きにより、その利用の停止または消去（以下、「利用停止等」といいます。）を求められた場合には、遅滞なく必要な調査を行います。\n前項の調査結果に基づき、その請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の利用停止等を行います。\n当社は、前項の規定に基づき利用停止等を行った場合、または利用停止等を行わない旨の決定をしたときは、遅滞なく、これをユーザーに通知します。\n前 2 項にかかわらず、利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって、ユーザーの権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じるものとします。"
          }), _jsx(_components.h2, {
            children: "第 9 条（安全管理措置）"
          }), _jsx(_components.p, {
            children: "当社は、利用者情報を正確かつ最新の内容に保つよう努めるとともに、不正なアクセス、改ざん、漏えい、滅失及び毀損から保護するため、必要かつ適切な安全管理措置を講じます。情報管理責任者を専任で設置し、情報管理責任者が適切に個人情報管理に関する活動を行います。"
          }), _jsx(_components.h2, {
            children: "第 10 条（プライバシーポリシーの変更）"
          }), _jsx(_components.p, {
            children: "本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。\n当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。"
          }), _jsx(_components.h2, {
            children: "第 11 条（お問い合わせ窓口）"
          }), _jsx(_components.p, {
            children: "本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。"
          }), _jsx(_components.p, {
            children: "住所：東京都千代田区神田和泉町 1 丁目 6 番 16 号ヤマトビル 405"
          }), _jsx(_components.p, {
            children: "社名：株式会社 Foodies Prime"
          }), _jsx(_components.p, {
            children: "代表取締役：菅井 貴志"
          }), _jsx(_components.p, {
            children: "担当部署：管理部"
          }), _jsx(_components.p, {
            children: "E メールアドレス：support@foodies-prime.com"
          }), _jsx(_components.p, {
            children: "【2023 年 3 月 1 日施行】"
          }), _jsx(_components.p, {
            children: "以上"
          })]
        })
      })
    }), "\n", _jsx(LpFooter, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
